import React from 'react'
import { MdArrowOutward } from "react-icons/md";  
import img1 from './images/broadcast_businessImg1.webp';
import img2 from './images/broadcast_businessImg2.webp';

const BusinessSection = () => {
    return (
        <section className="py-4 position-relative" style={{ overflow: 'hidden' }}>
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1,
                    marginTop: 60
                }}
            >
                {/* Heading */}
                <div style={{ textAlign: "center", marginBottom: "50px" }}>
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Why fast-growing businesses love{' '}
                        <span
                            style={{
                                fontFamily: 'Poppins',
                                fontWeight: 600,
                                background: 'linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)',
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                color: 'transparent',
                            }}
                        >
                            Vertex Suite
                        </span>
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            marginTop: 10,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.5,
                        }}
                    >
                        Take a look at the accolades and awards Vertex Suite has scored as proof of the
                        love customers have for our product.
                    </p>
                </div>

                {/* Cards */}
                <div className="business-grid">
                    <div className="biz-card">
                        <img src={img1} alt="Case Study 1" className="biz-img" />
                        <div className="biz-content">
                            <h3 className="biz-title">
                                How Vertex Suite Helped Qatar Insurance Company Generate 2X More Leads on WhatsApp
                            </h3>
                            <p className="biz-desc">
                                From doubling leads to improving CSAT — discover how Qatar Insurance Company transformed
                                their WhatsApp Business automation with Vertex Suite.
                            </p>
                            {/* Arrow link */}
                            <a href="/whatsapp-broadcast" className="arrow-link">
                                <MdArrowOutward />
                            </a>
                        </div>
                    </div>

                    <div className="biz-card">
                        <img src={img2} alt="Case Study 2" className="biz-img" />
                        <div className="biz-content">
                            <h3 className="biz-title">
                                Maximizing Conversions and Streamlining Support: Hugg’s Transformation with Vertex Suite
                            </h3>
                            <p className="biz-desc">
                                See how Hugg boosted efficiency, enhanced customer support, and multiplied conversion rates
                                with Vertex Suite’s automation platform.
                            </p>
                            {/* Arrow link */}
                            <a href="/whatsapp-broadcast" className="arrow-link">
                                <MdArrowOutward />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
        .business-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-top: 40px;
        }
        .biz-card {
          background: #fff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0,0,0,0.06);
          display: flex;
          flex-direction: column;
          transition: transform 0.3s ease;
          position: relative;
        }
        .biz-card:hover {
          transform: translateY(-6px);
        }
        .biz-img {
          width: 100%;
          height: auto;
          object-fit: cover;
        }
        .biz-content {
          padding: 80px 20px 40px; 
          position: relative;
        }
        .biz-title {
          margin-top: -2.7rem;
          font-size: 1.2rem;
          font-weight: 600;
          font-family: Lato;
          color: #1d1d1f;
        }
        .biz-desc {
          font-size: 1rem;
          font-family: Lato;
          font-weight: 400;
          line-height: 1.3;
          color: #555;
          margin-top: 1rem;
        }
        /* Arrow icon style */
        .arrow-link {
          position: absolute;
          bottom: 18px;
          right: 18px;
          font-size: 1.4rem;
          color: #242121;
          transition: color 0.3s ease;
        }
        .arrow-link:hover {
          color: #0c5da9; /* hover like link */
          cursor: pointer;
        }
        @media (max-width: 900px){
          .business-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
        </section>
    )
}

export default BusinessSection
